import React from 'react';
import {ScrollView, StyleSheet} from 'react-native';

import ProductTileAbbreviatedHorizontal from '../../components/ProductTileAbbreviatedHorizontal';
import ContentView from '../../components/ui-controls/layout/ContentView';
import Text from '../../components/ui-controls/Text';
import {AppRoute} from '../../models/AppRoute';
import {RouteNavigatorScreenProps} from '../../models/navigationTypes';
import theme from '../../style/theme';

const OrderViewScreen = ({
  route,
}: RouteNavigatorScreenProps<AppRoute.ACCOUNT_ORDER_VIEW>) => {
  const {order} = route.params;

  const renderOrderItem = (item: any) => (
    <ProductTileAbbreviatedHorizontal
      item={item}
      key={item.id}
      pressCallback={() => null}
      showPreviousQuantity
    />
  );

  return (
    <ContentView>
      <ScrollView>
        <Text style={styles.heading}>Items in Order:</Text>
        {order.order_lines.filter(ol => !ol.charge).map(renderOrderItem)}
      </ScrollView>
    </ContentView>
  );
};

export default OrderViewScreen;

const styles = StyleSheet.create({
  heading: {
    fontSize: 16,
    fontWeight: '600',
    color: theme.colour.text.heading.primary,
    marginBottom: 16,
    alignSelf: 'center',
  },
});
